import { Component, OnInit } from "@angular/core";
import { ServerService } from "../../../shared/services/server.service";
import { ActivatedRoute } from "@angular/router";
import { UserInfo } from "../../header/header.component";
import { EventService } from "../../../shared/services/event.service";
import { IObject } from "../../../shared/models/models";
import * as moment from "moment";
import { ToastrService } from 'ngx-toastr';

import { rolesEnum } from '../../../shared/models/models';

export interface Investments {
  amount: number;
  amount1: number;
  amount2: number;
  amount3: number;
  amount4: number;
  factDate: number;
  investYear?: number;
  isOwnAmount?: boolean;
  mioTitle?: string;
}
export interface SendData {
  LivingComplexId: number;
  FactDate: string;
  IsOwnAmount: boolean;
  Amount?: number;
  Amount1?: number;
  Amount2?: number;
  Amount3?: number;
  Amount4?: number;
}

@Component({
  selector: "app-object-financing",
  templateUrl: "./object-financing.component.html",
  styleUrls: ["./object-financing.component.scss"]
})
export class ObjectFinancingComponent implements OnInit {

  rolesEnum = rolesEnum;

  object: IObject = null;
  loading: boolean = false;

  livingComplexId: number;
  completeDatesOwnAmount = {};
  completeDatesBdDevelopment = {};
  calendarModalOwnAmount: boolean = false;
  calendarModalBdDevelopment: boolean = false;
  financeGraphicModal: boolean = false;

  own_investments: number;
  bd_investments: number;
  own_investments2: number;
  bd_investments2: number;

  all_investments: number;
  cost_construction: number;
  cost_construction2: number;
  total_flat_area: number;
  total_flat_count: number;

  total_fact_btn_first: number = 0;
  total_fact_btn_second: number = 0;

  data: Investments[] = [];
  valuesLoading: boolean = false;

  access: boolean[] = [false, false];

  public user: UserInfo = null;
  mioReadOnlyUserFlag: boolean = false;

  investmentsTable: Investments[] = [];
  investor_type: string = "own";
  bdDate: string = null;
  ownDate: string = null;
  openedCalendar: string = "";
  financingObject =false;
  bdInv: number;
  ppInv: number;

  obj: SendData[] = [];

  constructor(
    private serverService: ServerService,
    private route: ActivatedRoute,
    private event: EventService,
    public toastr: ToastrService
  ) {}

  month = "";

  ngOnInit() {
    this.getUser();
    this.route.parent.params.subscribe(params => {
      this.livingComplexId = params.id;
      this.getAllValues(this.livingComplexId).then(() => {
        this.getRealizationData();
        this.getInvestStatus("first");
        this.getInvestStatus("second");
      });
    });

    this.month = this.getMonthName();
    this.getTotalFactBtn();
    this.event.invest.subscribe(res => {
      this.investmentsTable = [];
      this.getTotalFactBtn();
    });


  }


  userRole: string = "";
  getUser() {
    let user = localStorage.getItem("user");
    if (user) {
      this.user = JSON.parse(user);
      this.user.roles.forEach(r1 => {
        if (r1 === "BDAdmin") {
          this.userRole = r1;
        }
      });
      if (user) {
        this.user = JSON.parse(user);
        if (this.user.roles.some(e => e === "MioReadOnlyUser")) {
          this.mioReadOnlyUserFlag = true;
        }
      }
    }
  }

  day: number = 1;
  year: number = 2018;

  getNowDateInTimestamp() {
    this.year = new Date().getFullYear();
    let month = new Date().getMonth();
    this.day = new Date().getDate();
    return new Date(this.year, month, this.day).getTime();
  }

  getAllValues(id: number) {
    return this.serverService.getObject(id).then(res => {
      this.object = res;
      this.own_investments = res.investments.own_investments;
      this.bd_investments = res.investments.bd_investments;
      this.own_investments2 = res.investments.own_investments2;
      this.bd_investments2 = res.investments.bd_investments2;
      this.all_investments = Math.round(
        this.own_investments + this.bd_investments
      );
      this.total_flat_area = res.total_flat_area;
      this.total_flat_count = res.total_flat_count;
      //this.cost_construction = this.total_flat_area / this.total_flat_count;
      this.valuesLoading = true;

      this.bdInv = this.calculateParagh(this.object.bdInvCost_ConstrWork,this.object.bdInvCost_TechnicalSuperv,this.object.bdInvCost_AuthorSuperv,this.object.bdInvCost_AddExp);
    this.ppInv = this.calculateParagh(this.object.ppInvCost_ConstrWork,this.object.ppInvCost_TechnicalSuperv,this.object.ppInvCost_AuthorSuperv,this.object.ppInvCost_AddExp);
    });
  }

  total_first = 0;
  total_second = 0;
  getTotalFactBtn() {
    let today = this.getNowDateInTimestamp();
    this.total_fact_btn_first = 0;
    this.total_first = 0;

    this.total_fact_btn_second = 0;
    this.total_second = 0;
    this.serverService.getInvestAmount(this.livingComplexId).then(res => {
      res.yearsInvests.map(r => {
        let dateTime = new Date(r.factDate).getTime();
        if (dateTime <= today) {
          this.total_first += r.isOwnAmount ? r.amount1 + r.amount2 + r.amount3 + r.amount4: 0;
          this.total_second += r.isOwnAmount ? 0 : r.amount1 + r.amount2 + r.amount3 + r.amount4;
        }

        this.investmentsTable.push({
          amount: r.amount,
          amount1 : r.amount1,
          amount2: r.amount2,
          amount3: r.amount3,
          amount4: r.amount4,
          factDate: dateTime,
          investYear: r.investYear,
          isOwnAmount: r.isOwnAmount,
          mioTitle: r.mioTitle
        });
      });
      this.loading = true;
    });
  }
  getAmountDataFromServer(own: boolean) {
    this.serverService.getInvestAmount(this.livingComplexId, own).then(res => {
      this.data = res.yearsInvests;
      if (own) {
        this.completeDatesOwnAmount = this.updateAmountData(this.data);
      } else {
        this.completeDatesBdDevelopment = this.updateAmountData(this.data);
      }
    });
  }


  completeDatesFunct(data, flag: string) {
    if(this.financingObject){
      for (let key in data) {
        let sameInvestment = this.investmentsTable.find(function(element) {
          return (
            element.factDate.toString() === key &&
            element.isOwnAmount === (flag === "own")
          );
        });
        if (!sameInvestment || sameInvestment.amount !== data[key]) {
          let new_obj = {
            LivingComplexId: this.livingComplexId,
            FactDate: key,
            IsOwnAmount: flag === "own",
            Amount1: data[key]?data[key][0]:0,
            Amount2: data[key]?data[key][1]:0,
            Amount3: data[key]?data[key][2]:0,
            Amount4: data[key]?data[key][3]:0
          };

          this.obj.push(new_obj);
          if (flag === "own") {
            this.ownDate = new_obj.FactDate;
            this.total_fact_btn_first += (new_obj.Amount1 + new_obj.Amount2 + new_obj.Amount3 + new_obj.Amount4);
          } else {
            this.bdDate = new_obj.FactDate;
            this.total_fact_btn_second += (new_obj.Amount1 + new_obj.Amount2 + new_obj.Amount3 + new_obj.Amount4);
          }
        }
      }
      if (this.editedDate !== null) {
        this.updateTable();
        this.editedDate = null;
      }

    } else {
      for (let key in data) {
        let sameInvestment = this.investmentsTable.find(function(element) {
          return (
            element.factDate.toString() === key &&
            element.isOwnAmount === (flag === "own")
          );
        });
        if (!sameInvestment || sameInvestment.amount !== data[key]) {
          let new_obj = {
            LivingComplexId: this.livingComplexId,
            FactDate: key,
            IsOwnAmount: flag === "own",
            Amount: data[key]
          };

          this.obj.push(new_obj);
          if (flag === "own") {
            this.ownDate = new_obj.FactDate;
            this.total_fact_btn_first += new_obj.Amount;
          } else {
            this.bdDate = new_obj.FactDate;
            this.total_fact_btn_second += new_obj.Amount;
          }
        }
      }
      if (this.editedDate !== null) {
        this.updateTable();
        this.editedDate = null;
      }
    }


  }

	calculateParagh(numb1: number, numb2: number, numb3: number, numb4: number) {
		let t1 = 0;
		let t2 = 0;
		let t3 = 0;
		let t4 = 0;

		if (numb1) {
			t1 = parseInt(numb1.toString());
		}
		if (numb2) {
			t2 = parseInt(numb2.toString());
		}
		if (numb3) {
			t3 = parseInt(numb3.toString());
		}
		if (numb4) {
			t4 = parseInt(numb4.toString());
		}
		return t1 + t2 + t3 + t4;
  }

  updateAmountData(rows: Investments[]) {
    if(this.financingObject) {
      let data = {};
    rows.forEach(r => {
      data[new Date(r.factDate).getTime()] = [r.amount1, r.amount2,r.amount3,r.amount4, ];
    });
    return data;

    } else {
      let data = {};
    rows.forEach(r => {
      data[new Date(r.factDate).getTime()] = r.amount;
    });
    return data;
    }

  }
  openCalendarModule(flag: string, editor: boolean, openedCalendar: string) {
    this.openedCalendar = openedCalendar;
    if (!editor) {
      this.editedDate = null;
    }
    if (flag === "own") {
      this.getAmountDataFromServer(true);
      //this.rewriteSetInvestments(this.obj, true);
      this.financingObject = true;
      this.calendarModalOwnAmount = true;
    } else {
      this.getAmountDataFromServer(false);
      this.financingObject = true;
      //this.rewriteSetInvestments(this.obj, false);
      this.calendarModalBdDevelopment = true;
    }
  }

  // rewriteSetInvestments(obj: SendData[], flag: boolean){
  //   obj.forEach((o) => {
  //     if(flag){
  //       this.completeDatesOwnAmount[new Date(o.FactDate).getTime()] = o.Amount;
  //     }else{
  //       this.completeDatesBdDevelopment[new Date(o.FactDate).getTime()] = o.Amount;
  //     }
  //   });
  // }

  getMonthName() {
    return this.event.getMonthName(new Date().getMonth() + 1);
  }

  realized_apartments: number;
  realization_fact_sum: number;
  realization_plan_sum: number;
  cost_constructionFact: number;

  //Используется для вычисления 1 м2 строительства
  getRealizationData() {
    return this.serverService.getFlatSales(this.livingComplexId).then(res => {
      this.realization_plan_sum = res.flatSales.realization_plan_sum;
      this.realization_fact_sum = res.flatSales.realization_fact_sum;
      this.realized_apartments = res.flatSales.realized_apartments;
      let x =
        (this.total_flat_area / this.total_flat_count) *
        this.realized_apartments;
      if (x === 0) {
        this.cost_constructionFact = 0;
      } else {
        this.cost_constructionFact = this.realization_fact_sum / x;
      }

      if (this.total_flat_area === 0) {
        this.cost_construction = 0;
        this.cost_construction2 = 0;
      } else {
        this.cost_construction =
          (this.bd_investments + this.own_investments) / this.total_flat_area;
        this.cost_construction2 =
          (this.bd_investments2 + this.own_investments2) / this.total_flat_area;
      }

      this.loading = true;
    });
  }

  openConfirmDialog: boolean = false;
  closedFlag: string | any = "";

  stopFirstFinancing(flag: string) {
    this.closedFlag = flag;
    this.openConfirmDialog = true;
  }

  confirmFinance() {
    this.serverService
      .setInvestStatus(this.livingComplexId, true, true)
      .then(res => {
        this.getInvestStatus("first");
      });
    this.serverService
      .setInvestStatus(this.livingComplexId, false, true)
      .then(res => {
        this.getInvestStatus("second");
      });
    this.openConfirmDialog = false;
  }

  firstFinanceBtn: boolean;
  secondFinanceBtn: boolean;

  getInvestStatus(flag: string) {
    let sendFlag = flag === "first";
    let result;
    this.serverService
      .getInvestStatus(this.livingComplexId, sendFlag)
      .then(res => {
        result = res;
        flag == "first"
          ? (this.firstFinanceBtn = result)
          : (this.secondFinanceBtn = result);
      });
  }

  cancelFinance() {
    this.openConfirmDialog = false;
  }

  uploadFile(files) {
    let fileTypeId = this.closedFlag == "first" ? 3 : 4;
    let fileToUpload = <File>files.item(0);
    let fileType = fileToUpload.type.substr(fileToUpload.type.indexOf("/") + 1);
    this.serverService
      .uploadObjectDocument(
        this.livingComplexId,
        fileType,
        fileToUpload,
        fileTypeId
      )
      .then(res => {
        if (res) {
          this.access[this.closedFlag == "first" ? 0 : 1] = true;
        }
      });
  }

  reverse_sum: boolean = false;
  reverse_date: boolean = false;
  reverse_investor: boolean = false;
  orderBy(sort_type: string) {
    if (sort_type === "summary") {
      this.sortArray("amount", this.investmentsTable, this.reverse_sum);
      this.reverse_sum = !this.reverse_sum;
    } else if (sort_type === "date") {
      this.sortArray("factDate", this.investmentsTable, this.reverse_date);
      this.reverse_date = !this.reverse_date;
    } else if (sort_type === "investor") {
      this.sortArray("mioTitle", this.investmentsTable, this.reverse_investor);
      this.reverse_investor = !this.reverse_investor;
    }
  }

  sortArray(property, array, reverse) {
    property = property.split(".");
    var l = property.length;
    if (reverse) {
      return array.sort(function(a, b) {
        var i = 0;
        while (i < l) {
          a = a[property[i]];
          b = b[property[i]];
          i++;
        }
        return a < b ? 1 : -1;
      });
    } else {
      return array.sort(function(a, b) {
        var i = 0;
        while (i < l) {
          a = a[property[i]];
          b = b[property[i]];
          i++;
        }
        return a < b ? -1 : 1;
      });
    }
  }

  editedDate: number = null;

  editInvestment(item: Investments) {
    this.editedDate = item.factDate;
    if (item.isOwnAmount) {
      this.openCalendarModule("own", true, "edit");
    } else {
      this.openCalendarModule("bd", true, "edit");
    }
  }

  stopFinancing() {
    this.stopFirstFinancing("first");
  }

  updateTable() {
    if (this.obj.length > 0) {
      this.investmentsTable = [];
      this.serverService.setInvestAmount(this.obj).then(() => {
        this.getAmountDataFromServer(true);
        this.getAmountDataFromServer(false);
        // this.getTotalFactBtn();
        this.obj = [];
        this.ownDate = null;
        this.bdDate = null;
        this.total_fact_btn_first = 0;
        this.total_fact_btn_second = 0;
      });
    }
  }

  clearData() {
    if (this.obj.length > 0) {
      this.obj = [];
      this.investmentsTable = [];
      this.ownDate = null;
      this.bdDate = null;
      this.total_fact_btn_first = 0;
      this.total_fact_btn_second = 0;
      this.getTotalFactBtn();
    }
  }

  changeInvestorType(type: string) {
    if (this.investor_type !== type) {
      this.investor_type = type;
      let sum = 0;
      let isOwnAmount = type === "own";
      for (let item of this.obj) {
        item.IsOwnAmount = isOwnAmount;
        sum += item.Amount;
      }
      if (isOwnAmount) {
        this.total_fact_btn_first = sum;
        this.total_fact_btn_second = 0;
        this.ownDate = this.bdDate;
        this.bdDate = null;
      } else {
        this.total_fact_btn_first = 0;
        this.total_fact_btn_second = sum;
        this.bdDate = this.ownDate;
        this.ownDate = null;
      }
    }
    if (type === "own") {
      this.calendarModalOwnAmount = true;
    } else {
      this.calendarModalBdDevelopment = true;
    }
  }

  calculate(v1: number, v2: number) {
    let t1 = 0;
    let t2 = 0;
    if (v1) {
      t1 = parseInt(v1.toString());
    }
    if (v2) {
      t2 = parseInt(v2.toString());
    }
    return t1 + t2;
  }
  changes: boolean = false;

  lastNoChanges: string;
  noChanges() {
    this.changes = true;
    // this.serverService.lastDate().then(r => {
    //   var dateTime = new Date(r);
    //   this.lastNoChanges = moment(dateTime).format("YYYY-MM-DD");
    // });
  }

  dateObj;
  acceptNoChanges() {
    this.dateObj = Date.now();
    this.serverService.noChanges(this.livingComplexId, this.dateObj, 1).then(
      r => {
        this.changes = false;
        this.toastr.success("Изменения сохранены!", "Успешно!");
      },
      (err: any) => {
        if (err.status == 500 || err.status == 0) {
          this.toastr.error(
            "К сожалению, сервер временно недоступен. Попробуйте повторить действие чуть позже!",
            "Ваши данные не сохранены!"
          );
        }
      }
    );
  }

  countRowSpanItems(item) {
    let count = 0;
    if (item.amount1) {
      count++;
    }
    if (item.amount2) {
      count++;
    }if (item.amount3) {
      count++;
    }if (item.amount4) {
      count++;
    }
      return count;
  }
}
